import HTTPClient from '../..'

export const deleteSavedEventsApi = async (events: string[]) => {
  const { data } = await HTTPClient.delete(`saved_events/${events}`)
  return data
}
